import { ProjectsHall } from '@/pages/radar/ProjectsHall';

export function ProjectsPage() {
  return (
    <div className="space-y-5 p-6 lg:p-8">
      <ProjectsHall
        hideHeader
        titleNode={
          <div>
            <h1 className="text-3xl font-semibold tracking-tight">项目大厅</h1>
            <p className="mt-1 text-sm text-neutral-600">
              查看全部已立项的 IP 项目 · 点击卡片直达脚本微调
            </p>
          </div>
        }
      />
    </div>
  );
}
